/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {ActionTree, Commit} from 'vuex';
import {RootState} from '@/store/types';
import {SettingStateInterface} from '@/store/modules/settings/types';
import {Vue} from 'vue-property-decorator';

/**
 * Actions file for application settings operations.
 *
 * Actions are functions that can be exported and called upon potentially in an asynchronous manner.
 * To add an action export a named const function. e.g. export const fnName = ({ commit }, {id, name}) => { ... }
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
export const actions: ActionTree<SettingStateInterface, RootState> = {
    /**
     * Update settings media.
     *
     * @param {Commit} commit
     * @param {string} media
     */
    updateMedia({commit}: {commit: Commit}, media: string[]): void {
        commit('updateMedia', media);
    },

    /**
     * Update language settings.
     *
     * @param {Commit} commit
     * @param {string} language
     */
    updateLanguage({commit}: {commit: Commit}, language: string): void {
        commit('updateLanguage', language);
    },

    /**
     * Cookie consent given.
     *
     * @param {Commit} commit
     */
    consentGiven({commit}: {commit: Commit}): void {
        commit('updateConsent', true);

        if (undefined !== Vue.$ga) {
            Vue.$ga.enable();
        }
    },

    /**
     * Cookie consent given.
     *
     * @param {Commit} commit
     */
    consentRevoked({commit}: {commit: Commit}): void {
        commit('updateConsent', false);
        if (undefined !== Vue.$ga) {
            Vue.$ga.disable();
        }
    },
};
